import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-mapping-report',
  templateUrl: './mapping-report.component.html',
  styleUrls: ['./mapping-report.component.css']
})
export class MappingReportComponent implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  dropdownOptions1 = ['Option 1', 'Option 2', 'Option 3'];
  dropdownOptions2 = ['Option A', 'Option B', 'Option C'];
  module: any[] = []
  reporttype: any[] = []
  submodule: any;
  graph: any[] = [];
  table: any[] = [];
  widget: any[] = [];
  widgetarr = [{ value: '' }];
  grapharr = [{ value: '' }];
  tabularr = [{ value: '' }];
  selectedWidgets = [];
  selectedtabular: any[] = [];
  selectedgraph: any[] = [];
  constructor(
    private _formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<MappingReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.firstFormGroup = this._formBuilder.group({
      graphName: [''],
      module: [''],
      subModule: ['']
    });

    this.secondFormGroup = this._formBuilder.group({
      dropdown1: [''],
      dropdown2: [''],
      // Add more dropdowns as needed
    });
  }
  ngOnInit(): void {
    console.log(this.data);
    this.submodule = this.data.reporttypes
    if (this.data) {
      this.module = this.data.module;
      this.graph = this.data.graph;
      this.table = this.data.table;
      this.widget = this.data.widget;
    }
    this.firstFormGroup.get('module').valueChanges.subscribe(value => {
      console.log('Dropdown 1 value changed:', value);
      if (value == 1) {
        this.reporttype = [{ name: 'main report', id: 1 }]
      } else if (value == 2 || value == 3 || value == 4 || value == 5) {
        this.reporttype = [{ name: 'Main report', id: 1 }, { name: 'Summary report', id: 2 }, { name: 'detail report', id: 3 }]
      } else {
        this.reporttype = [{ name: 'other report', id: 4 }]

      }
    });
    this.firstFormGroup.get('subModule').valueChanges.subscribe(value => {
      console.log('Dropdown 2 value changed:', value);
    })
  }


  onClose(): void {
    this.dialogRef.close();
  }
  addItem(key: any): void {
    switch (key) {
      case 1:
        this.widgetarr.push({ value: '' });
        break;
      case 2:
        this.grapharr.push({ value: '' });
        break;
      case 3:
        this.tabularr.push({ value: '' });
        break;

      default:
        break;
    }
  }

  removeItem(index: number, key: any): void {
    switch (key) {
      case 1:
        this.widgetarr.splice(index, 1);
        this.selectedWidgets.splice(index, 1);
        break;
      case 2:
        this.grapharr.splice(index, 1);
        this.selectedgraph.splice(index, 1);
        break;
      case 3:
        this.tabularr.splice(index, 1);
        this.selectedtabular.splice(index, 1);
        break;

      default:
        break;
    }
  }

  onSelect(event: any, index: number, type: any): void {
    switch (type) {
      case 1:
        const selectedValue = event.target.value;
        this.selectedWidgets[index] = selectedValue;
        console.log('Selected Widgets:', this.selectedWidgets);

        break;
      case 2:
        const selectedValue1 = event.target.value;
        this.selectedgraph[index] = selectedValue1;
        console.log('Selected graphs:', this.selectedgraph);

        break;
      case 3:
        const selectedValue2 = event.target.value;
        this.selectedtabular[index] = selectedValue2;
        console.log('Selected tabular:', this.selectedtabular);
        break;

      default:
        break;
    }
  }

  saveReport(): void {
    this.dialogRef.close({basic_Details:this.firstFormGroup.value,widget:this.selectedWidgets,graph:this.selectedgraph,tabular:this.selectedtabular});
  }
}
